import React        from 'react';
import PropTypes    from 'prop-types';
import Translations from '../../../../utils/Translations';
import Tag          from './Tag';

class TagsCloud extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isExpanded: props.tags.length <= TagsCloud.propTypes.showOnly || props.selected.length > 0,
		};

		this.onTagToggle  = this.onTagToggleHandler.bind(this);
		this.onListToggle = this.onListToggleHandler.bind(this);
	}

	onTagToggleHandler(tag, e) {
		this.props.onToggle(tag, e);
	}

	onListToggleHandler() {
		this.setState({
			isExpanded: !this.state.isExpanded,
		});
	}

	isEqual(selectedTags, tag) {
		return selectedTags.find(selectedTag => selectedTag?.toLowerCase() === tag.toLowerCase());
	}

	render() {
		const showTags = this.state.isExpanded ? this.props.tags : this.props.tags.slice(0, this.props.showOnly);
		const tags     = (showTags.filter(
			(filteredTags) => (!this.props.onlySelected || this.props.selected.indexOf(filteredTags) !== -1)).map(
				(tag, key) => (
					<Tag
						tag			 = {tag}
						key			 = {key}
						navigateTo   = {this.props.navigateTo || null}
						onToggle     = {this.onTagToggle}
						isSelected   = {this.isEqual(this.props.selected, tag)}
						isDisabled   = {this.props.isDisabled}
						isStandalone = {this.props.isStandalone}
						link	     = {this.props.links.find(link => link.tagGroup === tag)?.link || ''}
					/>
				)
			)
		);

		const standaloneTags = tags.length > 0 ? (tags.length === 1 ? tags[0] : <span>{tags}</span>) : null;

		const content = this.props.isStandalone ? standaloneTags : (
			<div className={'video-grid__filter--column -tags-column' + (this.props.additionalClassNames ? ' ' + this.props.additionalClassNames : '')}>
				{this.props.showLabel && <label className="video-grid__filter-field-label">
					{Translations.get('VideoGridFilterKeywordsLabel')}
				</label>}
				{tags}
				{this.props.useIcon && <div onClick={this.onListToggle} className={'tags-expander h-text-align-center -has-icon'}>
					{!this.state.isExpanded &&
					<i className={'icon -icon-plus-full video-pad-left-10 video-grid__filter-bar--toggle-button -size-xxs'} />}
					{this.state.isExpanded &&
					<i className={'icon -icon-minus-full video-pad-left-10 video-grid__filter-bar--toggle-button -size-xxs'} />}
				</div>}
				{!this.props.useIcon && <div onClick={this.onListToggle} className={'tags-expander h-text-align-center'}>
					{!this.state.isExpanded && <span>{Translations.get('VideoGridFilterKeywordsExpand')}</span>}
				</div>}
			</div>);

		return content;
	}
}

TagsCloud.propTypes = {
	additionalClassNames: PropTypes.string,
	onToggle:             PropTypes.func.isRequired,
	tags:                 PropTypes.arrayOf(PropTypes.string),
	selected:             PropTypes.arrayOf(PropTypes.string),
	showOnly:             PropTypes.number,
	isDisabled:           PropTypes.bool,
	isStandalone:         PropTypes.bool,
	onlySelected:         PropTypes.bool,
	showLabel:            PropTypes.bool,
	useIcon:              PropTypes.bool,
	links:                PropTypes.array,
};

TagsCloud.defaultProps = {
	additionalClassNames: '',
	tags:                 [],
	selected:             [],
	showOnly:             25,
	isDisabled:           false,
	isStandalone:         false,
	onlySelected:         false,
	showLabel:            true,
	useIcon:              false,
	links:                []
};

export default TagsCloud;
